import { Grid, Typography } from "@mui/material";
import StarBorderIcon from '@mui/icons-material/StarBorder';

function ExtensionModalHeading(props) {
  return (
    <Grid container spacing={2} alignItems={'center'}>
      <Grid item xs={3} sm={3}  md={3} lg={3} xl={2}>
        <Grid
          container
          width={'50px'}
          height={'50px'}
          justifyContent={'center'}
          alignItems={'center'}
          style={{ background: '#f4af40', borderRadius: '20px',width:'50px',height:'50px' }}
        >
          <Grid item>
            <StarBorderIcon style={{ fontSize: '30px',marginTop:'5px', color: '#fff' }}></StarBorderIcon>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={9} sm={9} md={9} lg={9} xl={10}>
        <Grid container direction={'column'}>
          <Grid item>
            <Typography style={{ fontSize: '15px', fontWeight: '600' }}>
              {props.heading}
            </Typography>
          </Grid>
          <Grid item style={{ marginTop: '5px' }}>
            <Typography style={{ fontSize: '13px', fontWeight: '500', color: '#707070' }}>
              {props.subHeading}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default ExtensionModalHeading;
